import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('business_account'),
    pluralInvitationDescription: defineMessage('you_have_count_number_c_ons_to_business_account'),
    singleInvitationDescriptionWithName: defineMessage('you_were_invited_to_the_me_by_displayname_email'),
    singleInvitationDescriptionWithoutName: defineMessage('you_were_invited_to_the_nt_by_displayname_email'),
    chooseAndAcceptButton: defineMessage('choose_and_accept'),
    acceptButton: defineMessage('accept'),
    declineButton: defineMessage('decline'),
};
